exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a.selectedFleet{font-weight:700}.nb{padding-top:0!important}.nb .vessel-list{padding-top:20px}ul.vessel-list{display:flex;flex-flow:row wrap;padding-bottom:30px;max-height:780px;overflow-y:scroll}ul.vessel-list::-webkit-scrollbar{width:10px}ul.vessel-list::-webkit-scrollbar-track{box-shadow:inset 0 0 5px #f0f0f0;border-radius:10px}ul.vessel-list::-webkit-scrollbar-thumb{background:#337cb9;border-radius:5px}ul.vessel-list li{padding:15px;min-width:170px;flex-basis:25%}@media (max-width:768px){ul.vessel-list li{flex:1;flex-basis:50%!important;padding:15px;min-width:50%!important}ul.vessel-list{flex-flow:row wrap!important}}ul.vessel-list.fleet-list.fleet-item li{width:180px;height:30px;padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/css-loader?minimize!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/style-rewriter.js?id=data-v-21e0df36!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=styles&index=0!./vue/fleet/components/Vessels.vue
// module id = 116
// module chunks = 3